import React, { FC } from "react";
import { useMediaQuery, Theme } from "@mui/material";

import { useMultistepFormStore } from "../../MultistepForm.store";
import Header from "./components/Header";
import Steps from "./components/Steps";
import Actions from "./components/Actions";

import { Box, Card, Skeleton, Stack } from "@components/base";
import { useGetFormSections } from "@api";
import { useUserStore } from "@store/user";

interface Stepper {}

const Stepper: FC<Stepper> = () => {
  const isDesktop = useMediaQuery<Theme>(({ breakpoints }) => breakpoints.up("md"));
  const {
    formSettings: {
      editMode,
      formBasics: { id },
    },
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { isLoadingFormSections } = useGetFormSections(user, id);

  return (
    <Card sx={{ height: isDesktop ? "100%" : "auto" }}>
      <Stack flexDirection="column" justifyContent="space-between" height="100%">
        {isDesktop && <Header />}
        {isLoadingFormSections && (
          <Box flex={1} overflow="auto">
            <Stack spacing={2} p={2}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Skeleton key={index} variant="rounded" width="100%" height={70} />
              ))}
            </Stack>
          </Box>
        )}
        {!isLoadingFormSections && (
          <>
            <Box flex={1} overflow="auto">
              <Steps />
            </Box>
            {!editMode && <Actions />}
          </>
        )}
      </Stack>
    </Card>
  );
};

export default Stepper;
